import axios from "axios";
import urls from "../constants/urls";

const api = axios.create({
  baseURL: urls.base, // We'll need to export 'base' from urls.js or use the hardcoded base url if not exported
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Changed to match current usage, or we can use a variable if we move to memory
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken) {
        try {
          // We can't use 'api' here to avoid infinite loops if this fails, or we can but carefully.
          // Using axios directly for the refresh call is safer.
          const response = await axios.post(urls.refreshToken, { refreshToken });

          if (response.status === 200) {
            const { accessToken, refreshToken: newRefreshToken } = response.data;

            localStorage.setItem("token", accessToken);
            localStorage.setItem("refreshToken", newRefreshToken);

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
            return api(originalRequest);
          }
        } catch (refreshError) {
          // Logout logic
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login"; // Or use history if available, but window.location is safer here
          return Promise.reject(refreshError);
        }
      } else {
        // No refresh token, logout
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
